<template>
  <div class="card">
    <div class="card-body">
      <h5 class="text-uppercase text-center text-muted my-4">
        {{ plan.name }} Plan
      </h5>
      <div class="row no-gutters align-items-center justify-content-center">
        <div class="col-auto">
          <div class="h2 mb-0">$</div>
        </div>
        <div class="col-auto">
          <div class="display-2 mb-0">{{ plan.price }}</div>
        </div>
      </div>
      <div class="h6 text-uppercase text-center text-muted mb-5">/ month</div>
      <div class="mb-3">
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item d-flex align-items-center justify-content-between px-0"
            v-for="item in plan.items"
            :key="item.name"
          >
            <small
              ><icon :type="item.icon" class="text-muted mr-2" />
              {{ item.name }}</small
            >
            <small>{{ item.details }}</small>
          </li>
        </ul>
      </div>
      <button
        @click="$emit('pickPlan', plan.id)"
        v-if="planId != vendor.billingPlan"
        class="btn btn-block btn-primary"
      >
        <icon type="plus-circle"></icon> Start with {{ plan.name }}
      </button>
      <button v-else disabled class="btn btn-block btn-success">
        <icon type="check"></icon> Your Current Plan
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlanCard",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    planId: function () {
      return process.env.NODE_ENV != "development"
        ? this.plan.stripe.live.plan
        : this.plan.stripe.dev.plan;
    },
  },
};
</script>
